import { FlightEventHandler, registerEventHandlerClass } from './flight'
import { api } from '../api'
import { writable } from 'svelte/store'

export default class ArsDevices extends FlightEventHandler {
	apiDevices = {}
	devices = {}

	constructor(flight) {
		super(flight)

		const { subscribe, set } = writable({});
		this.subscribe = subscribe 
		this.set = set

		api.devices.get()
		this.deviceUnsubscribe = api.devices.store.subscribe(d => {
			this.apiDevices = d

			this.devices[this.flight.arsDeviceId] = d[this.flight.arsDeviceId]
			const attachedDevices = Object.values(d).filter(d => d.parentDeviceId === this.flight.arsDeviceId)
			for (const dev of attachedDevices) {
				this.devices[dev.id] = dev
			}

			this.set(this.devices)

			setTimeout(this.deviceUnsubscribe, 0)
		})
	}

	handleKeyframe(keyframe) {
		this.devices = {...keyframe.arsDevices}
		this.set(this.devices)
	}

	handleFlightStep(message) {
		if (message.type == 'DEVICE_UPDATE') {
			this.devices[message.device.id] = message.device
			this.set(this.devices)
		}
	}

	cleanup() {
		super.cleanup()

		if (this.deviceUnsubscribe) {
			this.deviceUnsubscribe()
			this.deviceUnsubscribe = null
		}
	}
}

registerEventHandlerClass(ArsDevices)